import { render } from "./VPAAConsolidatedReportsDialog.vue?vue&type=template&id=50e5078c"
import script from "./VPAAConsolidatedReportsDialog.vue?vue&type=script&lang=js"
export * from "./VPAAConsolidatedReportsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__